export default "__VITE_ASSET__D3lcd_Bl__"